import { createContext,useState } from 'react';
import './App.css';
import { Header, FileUpload } from './Components';

export const global=createContext();


function App() {
  const [newFile,setNewFile] = useState(false)
  return (
    <>
      <global.Provider value={{newFile,setNewFile}}>

      <Header />
      <FileUpload />

      </global.Provider>
    </>
  );
}

export default App;
